<div class="homepage-wrapper" fxFlexFill fxLayoutAlign="center" fxLayout="column">
  <div class="wrap" fxFlex fxLayoutAlign="center">
    <div class="homepage-container" fxFlex="62" fxLayout="column" fxFlex.lt-md="95">
      <div class="homepage-header" fxLayout="column" fxLayoutAlign="center center">
        <h1 style="margin-bottom: 0" fxHide.lt-md="true">SlickChain</h1>
        <p>{{ 'HOME.INTRO_TEXT' | translate }}</p>
      </div>
    </div>
  </div>
  <div class="content-box-container" fxFlex fxLayoutAlign="center">
    <div class="content" fxFlex="40" fxFlex.lt-md="100" fxLayout="column" style="background: white" fxLayoutGap="3em">
      <div class="content-box-header" fxLayout="column" fxLayoutAlign="center center">
        <h2>Slick Chain</h2>
        <p style="text-align: center">{{ 'HOME.DESCRIPTION_TEXT' | translate }}</p>
      </div>
      <div class="contentBox" *ngFor="let cb of contentBoxes;let i=index" fxLayout="row" fxLayoutAlign="center center" inViewport (inViewportAction)="cbInView($event,cb)">
        <ng-container *ngIf="i%2===0">
          <div class="contentBox-image animate__animated" fxFlex="0 0 50" [ngClass]="cb.inView?'animate__fadeInRight':''">
            <img [src]="cb.image" alt="" style="max-width: 100%">
          </div>
          <div class="contentBox-content" fxLayout="column" fxFlex>
            <h3>{{cb.header}}</h3>
            <p s>{{cb.content}}</p>
          </div>
        </ng-container>
        <ng-container *ngIf="i%2!==0">
          <div class="contentBox-content" fxLayout="column" fxFlex="">
            <h3>{{cb.header}}</h3>
            <p>{{cb.content}}</p>
          </div>
          <div class="contentBox-image animate__animated" fxFlex="0 0 50"  [ngClass]="cb.inView?'animate__fadeInLeft':''">
            <img [src]="cb.image" alt="" style="max-width: 100%">
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="popularity-wrapper" fxFlex.lt-md="25rem" fxFlex fxLayoutAlign="center">
    <div class="popularity-container" fxFlex.lt-md="100" fxFlex="50" style="position: relative" fxLayoutAlign=" center" fxLayout="column">
      <img src="/assets/images/map.png" alt="" style="max-width: 100%;opacity: .4">
      <div class="popularity-content" fxLayout="column" fxLayoutAlign="center center"
           style="position: absolute;margin-top: 50px">
        <h3 style="text-align: center;font-size: 1.8em">{{ 'HOME.POPULARITY_TITLE' | translate }}</h3>
        <div class="countries-container" fxLayout="row" fxLayoutAlign="center">
          <div class="countries" fxLayout="row wrap" fxLayoutGap="1em grid" fxFlex="60" fxFlex.lt-md="95">
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">USA</span>
              <div class="currency-flag currency-flag-usd"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">Singapore</span>
              <div class="currency-flag currency-flag-sgd"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">United Kingdom</span>
              <div class="currency-flag currency-flag-gbp"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">Brazil</span>
              <div class="currency-flag currency-flag-brl"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">Australia</span>
              <div class="currency-flag currency-flag-aud"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">Japan</span>
              <div class="currency-flag currency-flag-jpy"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">Canada</span>
              <div class="currency-flag currency-flag-cad"></div>
            </div>
            <div class="single-country" fxLayout="row-reverse" fxLayoutGap="1em" fxLayoutAlign=" center" fxFlex="48">
              <span fxFlex="1 1 60">South Africa</span>
              <div class="currency-flag currency-flag-zar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="counters-row" fxLayout="row" style="padding-top: 40px" fxLayoutAlign="space-evenly" fxShow.lt-md="false" inViewport
       (inViewportAction)="inViewCounter($event)">
    <div class="counter" *ngFor="let counter of counters" fxLayout="column" fxLayoutAlign="center center">
      <div class="counter-dot"></div>
      <div class="counter-value" [countUp]="counter.current" [options]="counterOptions"
           [reanimateOnClick]="false"></div>
      <div class="counter-title">{{counter.label}}</div>
    </div>
  </div>
  <div class="clear" fxLayout="row" style="margin: 3em 0"></div>
</div>
